export default __webpack_public_path__ + "static/media/user.f593b483.svg";